import React from 'react'

import classNames from 'classnames'
import { FormCheckboxProps } from './types'

export const FormCheckbox = ({ field, form, ...props }: FormCheckboxProps): JSX.Element => {
  const { touched, errors } = form
  const hasError = touched[field.name] && errors[field.name]
  const groupClass = `donate-form-group-${field.name.replace('_', '-')}`
  const inputProps = field as HTMLProps<HTMLInputElement, typeof props>
  return (
    <div className={classNames(props.className, groupClass)}>
      <label className="generic-custom-radio-field" htmlFor={field.name}>
        <input type="checkbox" {...inputProps} id={field.name} defaultChecked={form.initialValues[field.name]} />
        <span className="generic-custom-radio" />
        <div>{props.label}</div>
      </label>
      {hasError && <span className="help-inline">{errors[field.name]}</span>}
    </div>
  )
}
